import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import AudioButton from "./AudioButton";
import { audioVideoSliceActions } from "../../Store/Slices/AudioVideoSlice";
import { Box, IconButton, Grid } from "@mui/material";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import { audioSmartCheck, audioSmartCheckUnScripted } from "../../Js/Common";
import RecordRTC, {
  RecordRTCPromisesHandler,
  StereoAudioRecorder,
} from "recordrtc";
import { uploadRecordFile, blobToBase64 } from "../../Js/Common";
import { currentAssetSliceActions } from "../../Store/Slices/CurrentAssetSlice";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import Confirmation from "../Modal/Confirmation";
import AudioButtonWave from "./AudioButtonWave";

// Global variables

const RecordButtonWave = (props) => {
  const dispatch = useDispatch();

  const [soundData, setSoundData] = useState(null);
  const [isFinished, setIsFinished] = useState(false);
  const [uri, setUri] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [smartCheckPercent, setSmartCheckPercent] = useState(0);
  const [attempt, setAttempt] = useState(0);

  const [recording, setRecording] = useState(null);
  const [stopRecordFlg, setStopRecordFlg] = useState(false);
  const [timer, setTimer] = useState(null);

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  const { serverRole } = useSelector((state) => state.defs);

  useEffect(() => {
    setIsPlaying(false);
    setRecording(null);
    setUri(null);
    setSmartCheckPercent(0);
    dispatch(currentAssetSliceActions.setRecordingContinueIndex(-1));
    dispatch(currentAssetSliceActions.setRecordingAudioContinueIndex(-1));
  }, [props.index, props.resetComponent]);

  useEffect(() => {
    console.log("!@#$URIIII", props.alreadyRecorded);
    if (props.alreadyRecorded) {
      setUri(props.alreadyRecorded);
    } else {
      setUri(null);
    }
    setIsPlaying(false);
    setRecording(null);
    setSmartCheckPercent(0);
  }, [props.alreadyRecorded]);

  useEffect(() => {
    if (recording) {
      if (props.index != undefined) {
        dispatch(
          currentAssetSliceActions.setRecordingContinueIndex(props.index)
        );
      } else {
        dispatch(currentAssetSliceActions.setRecordingContinueIndex(0));
      }
    } else {
      dispatch(currentAssetSliceActions.setRecordingContinueIndex(-1));
    }
  }, [recording]);

  useEffect(() => {
    if (isPlaying) {
      if (props.index != undefined) {
        dispatch(
          currentAssetSliceActions.setRecordingAudioContinueIndex(props.index)
        );
      } else {
        dispatch(currentAssetSliceActions.setRecordingAudioContinueIndex(0));
      }
    } else {
      dispatch(currentAssetSliceActions.setRecordingAudioContinueIndex(-1));
    }
  }, [isPlaying]);

  async function startRecording() {
    try {
      console.log("Requesting permissions..");
      let stream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: false,
      });
      let recorder = new RecordRTCPromisesHandler(stream, {
        type: "audio",
        audioType: "audio/wav",
        mimeType: "audio/wav",
        recorderType: StereoAudioRecorder,
      });

      recorder.startRecording();
      if (props.unscripted) {
        setTimer(
          setTimeout(() => {
            setStopRecordFlg(true);
          }, +process.env.REACT_APP_RECORD_TIMEOUT * 1000)
        );
      }
      dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
      if (props.startRecord) {
        props.startRecord(true);
      }
      setRecording(recorder);
      console.log("Recording started");
    } catch (err) {
      console.error("Failed to start recording", err);
    }
  }

  async function stopRecording() {
    console.log("Stopping recording..");
    await recording.stopRecording();
    if (props.startRecord) {
      props.startRecord(false);
    }
    setRecording(undefined);
    clearTimeout(timer);
    setTimer(null);
    const blob = await recording.getBlob();
    const localUri = URL.createObjectURL(blob);
    setUri(localUri);
    if (props.recordedAudio) {
      props.recordedAudio(localUri);
    }
    let uploadFlag = false;
    if (
      userInfo.rolesInfo &&
      userInfo.rolesInfo.title.toLowerCase() == "learner"
    ) {
      uploadFlag = true;
    }

    if (
      props.checkOnPause &&
      serverRole &&
      serverRole.toLowerCase() == "web_host"
    ) {
      let response;
      dispatch(commonSliceActions.setLoader(true));
      if (props.unscripted) {
        response = await audioSmartCheckUnScripted(
          blob,
          uploadFlag,
          userInfo.uid,
          userInfo.site_uuid
        );
      } else {
        response = await audioSmartCheck(
          blob,
          props.textToCheck ? props.textToCheck : "",
          uploadFlag,
          userInfo.uid,
          userInfo.site_uuid
        );
      }
      console.log("response.smartCheck.data", response);

      if (!response.error) {
        console.log("response.smartCheck.data", response.smartCheck.data);
        if (props.unscripted) {
          setSmartCheckPercent(
            +response.smartCheck.data.speakers[0]?.metrics?.general_scores?.elsa
              ?.pronunciation_score
          );
        } else {
          setSmartCheckPercent(
            +response.smartCheck.data.utterance[0].nativeness_score
          );
        }
        props.smartCheck(response.smartCheck.data, response.filename);

        setAttempt(attempt + 1);
      }
      dispatch(commonSliceActions.setLoader(false));
    } else {
      if (uploadFlag && props.checkOnPause) {
        let filename = await uploadRecordFile(blob);
        props.smartCheck("site_server", filename.data.id);
      }
      if (uploadFlag && !props.checkOnPause && props.smartCheck) {
        let filename = await uploadRecordFile(blob);
        props.smartCheck("web_host", filename.data.id);
      }
    }
    if (props.uploadOnPause) {
      // let content = await blobToBase64(blob);
      // console.log("content", content);
      let filename = await uploadRecordFile(blob);
      props.uploadedAudioName(filename.data.id);
    }
  }

  return (
    <Grid container sx={{height: '16vh'}}>
      <Grid xs={2} item alignSelf={"center"}>
        <IconButton
          onClick={recording ? stopRecording : startRecording}
          sx={{
            mx: 1,
            border: 1,
            alignSelf: "center",
            borderColor: "#EFEFEF",
            backgroundColor: "#FFFFFF",
            boxShadow: 2,
            color: recording ? "primary.error" : "primary.main",
            "&:hover": {
              backgroundColor: "#EFEFEF",
              color: recording ? "primary.error" : "primary.main",
            },
          }}
          size={props.size ? props.size : "medium"}
          // disabled={
          //   (!props.disablePercentageLimitOff &&
          //     smartCheckPercent >=
          //       +process.env.REACT_APP_SMART_CHECK_DISABLE_PERCENTAGE) ||
          //   (props.numberOfAttemptes &&
          //     userInfo.rolesInfo.title.toLowerCase() == "learner" &&
          //     +props.numberOfAttemptes == +attempt) ||
          //   props.disabled ||
          //   isPlaying ||
          //   props.disabledAll
          // }
        >
          <KeyboardVoiceIcon
            sx={{
              "@media (min-width: 1636px)": {
                fontSize: "2rem",
              },
            }}
          />
        </IconButton>
      </Grid>
      <Grid xs={10} item>
        {uri && (
          <AudioButtonWave
            localUri={uri}
            playStatus={(status) => setIsPlaying(status)}
            id={"wave2"}
          ></AudioButtonWave>
        )}
      </Grid>
      <Confirmation
        visible={stopRecordFlg}
        primaryText={"Maximum recording time is 30 seconds."}
        image={"error"}
        alert={true}
        toggleModal={(flag) => setStopRecordFlg(flag)}
        timeout={5000}
        onClose={stopRecording}
        UX={true}
      ></Confirmation>
    </Grid>
  );
};

export default RecordButtonWave;
